import React from 'react';
import { CheckCircle } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function OfferBlock() {
  const features = ['Identificar qué alimentos latinos están inflamando tu abdomen (sin que lo sepas)', 'Aprender sustituciones simples que no sacrifican sabor', 'Seguir un plan de rescate de 7 días paso a paso', 'Recuperar energía y sentir tu ropa más cómoda en pocos días'];
  return <section id="offer" className="bg-forest text-cream py-24 md:py-32 relative overflow-hidden" data-id="element-67">
      {/* Decorative background elements */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(201,168,76,0.15)_0%,transparent_60%)] pointer-events-none" data-id="element-68"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-xl relative z-10" data-id="element-69">
        <div className="bg-dark/60 border border-sage/30 rounded-lg backdrop-blur-md shadow-2xl overflow-hidden" data-id="element-70">
          {/* Top Badge */}
          <div className="bg-sage/15 border-b border-sage/20 py-3 px-6 text-center" data-id="element-71">
            <span className="text-sage font-bold text-sm tracking-wider uppercase font-body" data-id="element-72">
              🔒 ACCESO DE LANZAMIENTO – EDICIÓN DE RESCATE 7 DÍAS
            </span>
          </div>

          <div className="p-8 md:p-12 text-center" data-id="element-73">
            {/* Pricing */}
            <div className="mb-6" data-id="element-74">
              <div className="text-xs text-cream/40 uppercase tracking-[0.2em] mb-1 font-body" data-id="element-75">
                PRECIO REGULAR
              </div>
              <div className="text-lg md:text-xl font-heading text-cream/35 line-through mb-6" data-id="element-76">
                $27 USD
              </div>

              <div className="text-sm text-gold uppercase tracking-[0.15em] mb-2 font-body font-bold" data-id="element-77">
                HOY SOLO
              </div>
              <div className="text-6xl md:text-7xl lg:text-8xl font-heading font-bold text-gold drop-shadow-lg leading-none" data-id="element-78">
                $9
                <span className="text-2xl md:text-3xl font-normal ml-2 align-top" data-id="element-79">
                  USD
                </span>
              </div>
            </div>

            {/* Support Text */}
            <p className="text-sm md:text-base text-sage font-body font-bold mb-1" data-id="element-80">
              Edición de Rescate Gastro-Inflamatorio
            </p>
            <p className="text-xs text-cream/50 font-body italic mb-10" data-id="element-81">
              Exclusivo para las primeras 100 lectoras
            </p>

            {/* Feature List */}
            <ul className="space-y-4 mb-10 text-left max-w-xs mx-auto" data-id="element-82">
              {features.map((feature, index) => <li key={index} className="flex items-start gap-3" data-id="element-83">
                  <CheckCircle className="w-5 h-5 text-sage flex-shrink-0 mt-0.5" strokeWidth={2} data-id="element-84" />
                  <span className="text-cream/90 font-body text-base" data-id="element-85">
                    {feature}
                  </span>
                </li>)}
            </ul>

            {/* Impact Phrase */}
            <p className="text-base md:text-lg text-cream/70 font-heading italic mb-10 max-w-sm mx-auto leading-relaxed" data-id="element-86">
              "Menos de lo que te cuesta seguir despertando inflamada una semana
              más."
            </p>

            {/* CTA Button */}
            <a id="cta-comprar" href="https://factorexpansion.com/cart/47401331589350:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="block w-full px-8 py-5 text-lg md:text-xl font-bold text-forest bg-gold hover:bg-gold/90 transition-all duration-300 rounded-lg shadow-xl hover:shadow-2xl hover:-translate-y-0.5 mb-5 font-body text-center" data-id="element-87">
              Sí, quiero empezar mi rescate hoy por $9
            </a>

            <div className="flex flex-col items-center justify-center gap-1 text-xs text-cream/40 font-body" data-id="element-88">
              <span data-id="element-89">🔒 Pago 100% seguro</span>
              <span data-id="element-90">📩 Descarga inmediata en tu correo</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}